import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneSpeech");
  return hybrid;
}
var latest = 0;
function start(options, onEvent) {
  if (typeof onEvent !== "function") {
    throw new TypeError("Speech.start: onEvent must be a function");
  }
  var session = ++latest;
  native().start(options, onEvent);
  return {
    stop: function stop() {
      if (session === latest) native().stop();
    },
    abort: function abort() {
      if (session === latest) native().abort();
    }
  };
}
var Speech = Object.freeze({
  isAvailable: function isAvailable() {
    return native().isAvailable();
  },
  getPermissions: function getPermissions() {
    return native().getPermissions().catch(rethrowNativeError);
  },
  requestPermissions: function requestPermissions() {
    return native().requestPermissions().catch(rethrowNativeError);
  },
  start
});
export {
  Speech
};
//# sourceMappingURL=index.native.js.map
